import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ max, value, texto }) => {
  const percentage = max > 0 ? (value / max) * 100 : 0;
  const percentageText = `${percentage.toFixed(2)}%`;

  return (
    <div className="progress-card-widget">
      <div className="progress-card-header">
        <p className="progress-card-title">{texto}</p>
        <span className="progress-card-meta">
          {value} de {max}
        </span>
      </div>
      <div className="progress-bar-container">
        <div
          className="progress-bar"
          style={{ width: `${percentage}%` }}
        ></div>
        <span className="progress-label">{percentageText}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
